import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import IconButton from '@mui/material/IconButton'

import * as S from './styles'

export interface ColumnPickerPaginationProps {
  query: string
  onNextPage: (query: string) => void
  onPreviousPage: (query: string) => void
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export const ColumnPickerPagination = ({
  query,
  onNextPage,
  onPreviousPage,
  hasNextPage,
  hasPreviousPage,
}: ColumnPickerPaginationProps) => (
  <S.PaginationContainer>
    <IconButton
      size="small"
      onClick={() => onPreviousPage(query)}
      disabled={!hasPreviousPage}
      data-test-id="pagination-back"
    >
      <ChevronLeftIcon fontSize="small" />
    </IconButton>
    <IconButton
      size="small"
      onClick={() => onNextPage(query)}
      disabled={!hasNextPage}
      data-test-id="pagination-forward"
    >
      <ChevronRightIcon fontSize="small" />
    </IconButton>
  </S.PaginationContainer>
)
